import { useContext } from 'react';
import { SfFunnelMenuContext } from './SfFunnelMenuProvider';
import { ConnectedSfFunnelMenu } from './ConnectedSfFunnelMenu';
import { useSelector } from 'react-redux';
import { selectFunnelMapSfFunnelById } from '../../../../../reducers/united-canvas/sfFunnelReducer';

export const CanvasStepConnectedSfFunnelMenu = () => {
  const { anchorEl, setAnchorEl } = useContext(SfFunnelMenuContext);
  const funnel = useSelector(selectFunnelMapSfFunnelById(anchorEl?.funnelId || ''));

  if (!anchorEl?.anchorEl || !funnel) {
    return null;
  }

  return (
    <ConnectedSfFunnelMenu
      anchorEl={anchorEl.anchorEl}
      onClose={() => setAnchorEl(null)}
      funnel={funnel}
      onDeleteOrRemove={() => setAnchorEl(null)}
    />
  );
};
